import { Info } from "lucide-react";
import IntegrationBuilderHeader from "../../../shared/IntegrationBuilderHeader";
import AutomatedModifiedAtFiltersTable from "./AutomatedModifiedAtFiltersTable";
import { Alert } from "@merge-api/merge-javascript-shared";

interface Props {
  integrationID: string;
}

const AutomatedModifiedAtFiltersTableContainer = ({ integrationID }: Props) => {
  return (
    <>
      <IntegrationBuilderHeader title="Automated modified_at filters" />
      <Alert
        title="What are automated modified_at filters?"
        color="gray"
        icon={<Info size={16} />}
        className="mb-6"
      >
        Our backend automatically applies “modified_at” timestamp filters to the supported Common
        Models below, eliminating the need to manually create “modified_at” Selective Sync filters.
        End users & customers will be able to use these automated filters like any other Selective
        Sync filter. Note that existing “modified_at” Selective Sync filters will override the
        corresponding automated filter.
      </Alert>
      <AutomatedModifiedAtFiltersTable integrationID={integrationID} />
    </>
  );
};

export default AutomatedModifiedAtFiltersTableContainer;
